import { useSyncExternalStore } from "react";

const EMPTY_SUBSCRIBE = () => () => {};

export function isEmbedded(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const inIframe = window.self !== window.top;
    const isStoryblokPreview =
      window.location.search.includes("_storyblok") ||
      document.referrer.includes("app.storyblok.com");
    return inIframe || isStoryblokPreview;
  } catch {
    // Cross-origin window access throws, which itself means we're embedded.
    return true;
  }
}

export function useIsEmbedded(): boolean {
  return useSyncExternalStore(EMPTY_SUBSCRIBE, isEmbedded, () => false);
}
